import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { getEffectiveDatesOptions } from 'global/services-helpers/domainService';
import { ddnjSICWarningMessage } from 'global/utils/sponsor-validations/ddnj/sicValidation';
import { makeAutoObservable } from 'mobx';
import { ReactNode } from 'react';
import { getRootStoreInstance, RootStore } from 'store/rootStore';

type DDNJQuoteProposalInfoFields = {
  proposalName: FormControl<string>;
  effectiveDate: FormControl<string>;
  zip: FormControl<string>;
  state: FormControl<string>;
  county: FormControl<string>;
  sic4: FormControl<string>;
};

export class DDNJQuoteProposalInfoFormDelegate {
  private readonly _rootStore: RootStore = getRootStoreInstance();
  public proposalForm: FormController<DDNJQuoteProposalInfoFields>;

  public get effectiveDatesOptions(): OptionType[] {
    return getEffectiveDatesOptions(this._rootStore.domainStoreV2.effectiveDates);
  }

  /** Shown as a warning `Alert` when the current SIC matches a non-blocking rule. */
  public get sicWarningMessage(): ReactNode | null {
    const sicValue = this.proposalForm.fields.sic4.value;
    return sicValue && sicValue.length === 4 ? ddnjSICWarningMessage(sicValue) : null;
  }

  constructor() {
    this.proposalForm = FormController.create(
      {
        proposalName: new FormControl<string>('', {
          validations: ['printableCharacters'],
        }),
        effectiveDate: new FormControl<string>(''),
      },
      {
        capabilities: [
          {
            type: 'zip',
            params: {
              zip: { optional: false },
              state: {
                customValidations: [
                  {
                    check: this._rootStore.domainStoreV2.isEligibleState,
                    msg: 'State is ineligible',
                  },
                ],
              },
            },
          },
          {
            type: 'sic',
            params: {
              additionalValidations: [
                {
                  check: this._rootStore.domainStoreV2.isEligibleSicCode,
                  msg: 'SIC Code is ineligible',
                },
              ],
            },
          },
        ],
      },
    );

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
